import FeatsManagePaneFeat from './FeatsManagePaneFeat';

export default FeatsManagePaneFeat;
export { FeatsManagePaneFeat };
